import React, { useCallback } from 'react';

// Components
import { HeartIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Heart';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

// Types
import type { EventConfig } from '@zola/tracking-contracts/src/configs';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';

// Utils
import { trackNavigationClicked } from '@zola/tracking-contracts/src/tracking';

export type BoardHeartProps = {
  businessUnit?: EventConfig['business_unit'];
  isPostAuthNav3Enabled?: boolean;
  link: string;
  navigationLevelPosition?: number;
  userContext?: UserContext;
};

const BoardHeart = ({
  businessUnit,
  isPostAuthNav3Enabled,
  link,
  navigationLevelPosition,
  userContext,
}: BoardHeartProps): JSX.Element => {
  const { is_guest: isGuest } = userContext || {};
  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      trackNavigationClicked({
        business_category: 'UNATTRIBUTED',
        business_unit: businessUnit || 'MARKETPLACE',
        navigation_level_1: 'FAVORITES',
        navigation_level_1_position: navigationLevelPosition || 1,
        navigation_type: 'UTILITY',
      });

      // Wait 500ms before redirecting to be sure the event has been sent (it doesn't return a promise...)
      setTimeout(() => {
        window.location.href = link;
      }, 500);
    },
    [businessUnit, link, navigationLevelPosition]
  );

  if (isGuest !== false) {
    return <></>;
  }

  return (
    <LinkV2
      aria-label="Your Favorites"
      className="nav-heart icon-link"
      href={link}
      onClick={handleClick}
      title="Favorites"
    >
      {isPostAuthNav3Enabled ? (
        <HeartIcon title="Favorites" height={20} width={20} />
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          className="nav-util__icon nav-heart__icon"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill="#fff" fillOpacity=".01" d="M0 0h20v20H0z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.534 2.592C3.552.44 6.807.411 8.858 2.505l.084.087L10 3.721l1.058-1.129c1.99-2.122 5.183-2.18 7.238-.173l.086.086.084.087c2.018 2.152 2.045 5.624.082 7.812l-.082.089-7.937 8.465a.715.715 0 01-1.017.04l-.041-.04-7.937-8.465c-2.045-2.182-2.045-5.719 0-7.9zm1.588 1.693c-1.147 1.223-1.169 3.192-.065 4.443l.065.072L10 16.136 16.88 8.8c1.146-1.224 1.168-3.192.081-4.426l-.064-.07-.066-.07a2.86 2.86 0 00-4.117-.018l-.068.07L10 7.105 7.354 4.286c-1.168-1.247-3.064-1.247-4.232 0z"
            fill="#505050"
          />
        </svg>
      )}
      <span className="hidden">Your Saved Ideas</span>
    </LinkV2>
  );
};

export default BoardHeart;
